// extracted by mini-css-extract-plugin
export default {"modalBody":"candidatePDFReportModal_modalBody__y0o8t"};